import { Schema as S } from "effect";

/** v1 maps light → DaisyUI `corporate`, dark → `business`. */
export const Theme = S.Literals(["light", "dark"]);
export type Theme = typeof Theme.Type;

export const daisyTheme = (theme: Theme): "corporate" | "business" =>
	theme === "light" ? "corporate" : "business";

export const toggle = (theme: Theme): Theme =>
	theme === "light" ? "dark" : "light";

const STORAGE_KEY = "theme";

/** The OS preference: what v1's "system" choice resolves to. */
export const systemTheme = (): Theme =>
	window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";

/** Read once in `init`; v1's "system" falls back to the OS preference. */
export const readStoredTheme = (): Theme => {
	const stored = localStorage.getItem(STORAGE_KEY);
	if (stored === "light" || stored === "dark") {
		return stored;
	}
	return systemTheme();
};

export const applyTheme = (theme: Theme): void => {
	localStorage.setItem(STORAGE_KEY, theme);
	document.documentElement.setAttribute("data-theme", daisyTheme(theme));
};
